import { ReactComponent as FlagIcon } from "./svg/lv-flag.svg";
import "../flag-icon.scss";

export const LVFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
